import { buildColorPropsSDKFactoryCreator } from './colorPropsSDKFactoryBuilder';
import type {
  IColorSDK,
  IColorWithStatesSDK,
} from './colorPropsSDKFactoryBuilder';

export type IBorderColorSDK = IColorSDK<'borderColor'>;

export type IBorderColorWithStatesSDK = IColorWithStatesSDK<'borderColor'>;

export const createBorderColorPropsSDKFactory =
  buildColorPropsSDKFactoryCreator('borderColor');
